// -- Colors

export default {
    primary: {
        main: "#B5111A",
        contrast: "#ffffff",
        light: "#E9131E",
        dark: "#841A1F",
    },
    secondary: {
        main: "#2D2E31",
        contrast: "#ffffff",
        light: "#4B4C50",
        dark: "#1A1B1E",
    },
    tertiary: {
        main: "#828388",
        contrast: "#ffffff",
        light: "#9E9FA3",
        dark: "#58595B",
    },
    common: {
        border: "#d8d8da",
        borderLight: "#f0f0f0", // Gray Shades -> Light
        borderDark: "#58595B", // Gray Shades -> Main
        accent: "#f0f0f0", // Gray Shades -> Light
        accentContrast: "#282525", // Text Color -> Main
        accentContrastLight: "#58595B", // Gray Shades -> Main
        background: "#ffffff",
        backgroundContrast: "#9E9FA3", // Text Color -> Main
        disabled: "#828388", // Gray Shades -> Light
        disabledDark: "#e0e0e0",
        // Custom
        backgroundHover: "#f5f5f5",
        borderLighter: "#ececed",
        borderDarker: "#999999",
        disabledLighter: "#f5f5f5",
        disabledLight: "#f0f0f0",
    },
    text: {
        main: "#828388", // Text Color -> Main
        accent: "#6C757D", // Text Color -> Accent
        disabled: "#999999", // Text Color -> Semi
        link: "#B5111A", // Primary -> Main
        linkHover: "#D32F2F", // Primary -> Dark
        linkAlt: "#282525", // Text Color -> Main
        linkAltHover: "#841A1F",
        input: "#282525", // Text Color -> Main
        // Custom
        lighter: "#999999", // Gray Shades -> Main
        titles: "#000000",
        dark: "#212121",
        almostDark: "#424242",
    },
    success: {
        main: "#4CAF50",
        contrast: "#ffffff",
        light: "#EEF7EE",
    },
    danger: {
        main: "#F44336",
        contrast: "#ffffff",
        light: "#F5E8EA",
    },
    warning: {
        main: "#FF9800",
        contrast: "#ffffff",
        light: "#FFF5E9",
    },
    unavailable: {
        main: "#6C757D",
        contrast: "#ffffff",
        light: "#E0E0E0",
    },
    info: {
        main: "#2196F3",
        contrast: "#ffffff",
    },
    neutral: {
        main: "#616161", // None
        contrast: "#ffffff", // None
        light: "#e0e0e0", // None
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#B5111A", // Primary -> Main
        hover: "#841A1F", // Primary -> Dark
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#7e7f86", // Text Color -> Accent
        disabled: "#d6d7dc", // Gray Shades -> Mid
    },
    button: {
        disabled: {
            main: "#d6d7dc", // Gray Shades -> Mid
            contrast: "#ffffff", // Black & White -> White
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#282525", // Text Color -> Main
        hover: "#841A1F", // Primary -> Dark
        accent: "#B5111A", // Primary -> Main
        accentHover: "#841A1F", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#ffffff", // None, look at main navigation background color
            contrast: "#282525", // Text Color -> Main
            hover: "#B5111A", // Primary -> Main
            underline: "#B5111A", // Primary -> Main
            accent: "#B5111A", // Primary -> Main
            accentContrast: "#ffffff", // None, should match "primary.contrast"
            accentHover: "#B5111A", // Primary -> Main
            separator: "#e1e2e7", // Border -> Border
            border: "#e1e2e7", // Border -> Border
        },
        secondaryNavigation: {
            main: "#841A1F", // Primary -> Dark
            contrast: "#ffffff", // None, should match "primary.contrast"
            hover: "#ffffff", // None, should match "primary.contrast"
        },
        megaMenuWithTabs: {
            tabsBackground: "#f7f8fc", // Gray Shades -> Light
            tabsBackgroundHover: "#ffffff",
        },
    },
    footer: {
        main: "#f7f8fc", // Gray Shades -> Light
        contrast: "#282525", // Text Color -> Main
        alt: "#841A1F", // Primary -> Dark
        altContrast: "#ffffff", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#e1e2e7", // Border -> Border
        contrast: "#282525", // Text Color -> Main
        hover: "#B5111A", // Primary -> Main
        selected: "#B5111A", // Primary -> Main
        selectedHover: "#841A1F", // Primary -> Dark
    },
    // Custom
    // pagination: {
    //     main: "#cccccc",
    //     hover: "#bbbbbb",
    // },
    user: {
        guest: "#474a4e",
        b2c: "#1A1B1E",
        b2b: "#007BFF",
    },
    table: {
        selected: "#aaaaaa",
        hover: "#ebeaeb",
    },
    shadow: {
        light: "rgba(48, 49, 51, 0.05)",
        base: "rgba(48, 49, 51, 0.1)",
    },
};

// primary: {
//     main: COLORS.primary.base,
//     contrast: COLORS.white,
//     // Custom
//     light: COLORS.primary.light,
//     dark: COLORS.primary.dark,
// },
// secondary: {
//     main: COLORS.secondary.base,
//     contrast: COLORS.white,
//     // Custom
//     light: COLORS.secondary.light,
//     dark: COLORS.secondary.dark,
// },
// tertiary: {
//     main: COLORS.tertiary.base,
//     contrast: COLORS.white,
//     // Custom
//     light: COLORS.tertiary.light,
//     dark: COLORS.tertiary.dark,
// },
// common: {
//     background: COLORS.white,
//     backgroundContrast: COLORS.text.base,
//     accent: COLORS.background.alt,
//     accentContrast: COLORS.text.base,
//     border: COLORS.border.base,
//     disabled: COLORS.disabled.base,
//     // Custom
//     disabledLighter: COLORS.disabled.lighter,
//     disabledLight: COLORS.disabled.light,
//     borderDark: COLORS.border.dark,
//     borderLighter: COLORS.border.lighter,
//     borderDarker: COLORS.border.darker,
//     backgroundHover: COLORS.background.hover,
// },
// text: {
//     main: COLORS.text.light,
//     titles: COLORS.text.base,
//     disabled: COLORS.text.lighter,
//     accent: COLORS.text.light,
//     link: COLORS.link.base,
//     // Custom
//     linkHover: COLORS.link.hover,
//     lighter: COLORS.text.lighter,
//     dark: COLORS.text.dark,
//     almostDark: COLORS.text.almostDark,
// },
// success: {
//     main: COLORS.success,
//     contrast: COLORS.successBackground,
// },
// danger: {
//     main: COLORS.error,
//     contrast: COLORS.errorBackground,
// },
// warning: {
//     main: COLORS.warning,
//     contrast: COLORS.warningBackground,
// },
// unavailable: {
//     main: COLORS.tertiary.base,
//     contrast: COLORS.white,
// },
// info: {
//     main: COLORS.info,
//     contrast: COLORS.text.base,
// },
// // Custom
// pagination: {
//     main: COLORS.pagination.base,
//     hover: COLORS.pagination.hover,
// },
// user: {
//     guest: COLORS.secondary.light,
//     b2c: COLORS.secondary.dark,
//     b2b: COLORS.primary.base,
// },
// table: {
//     selected: "#aaaaaa",
//     hover: "#ebeaeb",
// },
